import React from 'react';
import _ from 'lodash';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { OAuthProviders } from 'common/utils/assets.utils';
import SearchInput from 'components/SearchInput';
import { clearPagingParams, isValidTerm } from './repositories-modal.service';
import OrgSelector from './OrgSelector';

const RepositoriesModalHeader = ({
  sensor_name,
  title,
  subtitle,
  term = '',
  setTerm,
  orgs,
  selectedOrg,
  setSelectedOrg,
  setPageParams,
  setLoading,
  setPage,
  searchCharsLimit
}) => {
  const shouldShowOrgSelector = _.isArray(orgs) && orgs.length > 0;

  const onChangeOrg = newOrg => {
    clearPagingParams({ setPage, setPageParams });
    setTerm('');
    setLoading(true);
    setSelectedOrg(newOrg);
  };

  return (
    <>
      <Flex items='center' pb='medium' pt='small'>
        <Flex direction='column'>
          <Flex direction='row' pb='medium' items='center' content='center'>
            <img
              src={_.get(OAuthProviders[sensor_name.toLowerCase()], 'logo')}
              alt=''
            />
            <Text size='x-x-large' pl='1rem' weight='400'>
              {title}
            </Text>
          </Flex>
          {subtitle}
        </Flex>
      </Flex>
      <Flex justify='space-between'>
        {shouldShowOrgSelector && (
          <OrgSelector
            orgs={orgs}
            selectedOrg={selectedOrg}
            onChange={onChangeOrg}
          />
        )}

        <Flex direction='column'>
          <Flex height='3rem'>
            <SearchInput
              placeholder='Search repository'
              value={term}
              onChange={term => {
                const badCharsRegex = new RegExp('\\s|\\:');
                if (badCharsRegex.test(term)) {
                  return;
                }

                if (isValidTerm(term, searchCharsLimit)) {
                  clearPagingParams({ setPage, setPageParams });
                }
                setTerm(term);
              }}
            />
          </Flex>
          <Flex height='1.5rem' pt='x-small'>
            {!isValidTerm(term, searchCharsLimit) && (
              <Text color='osloGray' data-testid='search-input-message'>
                {`Search requires at least ${searchCharsLimit} characters`}
              </Text>
            )}
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};

export default RepositoriesModalHeader;
